var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobeGrid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 2050 2050",
    "data-name": "Layer 3",
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:var(--color-text);}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M830.4,1228.3q4.1,41.1,9.6,80.9c12.2,86.2,29.5,163.3,51.5,229.3,10.3,30.6,21.4,58.4,33.2,82.6a610.2,610.2,0,0,0,200.6,0c11.8-24.2,22.9-52,33.2-82.6,22-66,39.3-143.1,51.5-229.3q5.6-39.7,9.6-80.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1226.2,911.7H823.8c-2,37.2-2.9,75-2.9,113.3s.9,76.1,2.9,113.3h402.4c2-37.2,2.9-75,2.9-113.3S1228.2,948.9,1226.2,911.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1243.9,483c31.9,95.9,54.5,212.1,66.1,338.7h284.3c-3.8-10.8-7.9-21.4-12.4-32a606.3,606.3,0,0,0-321.6-321.6c-8.3-3.5-16.7-6.8-25.1-9.9C1238.1,466.2,1241,474.5,1243.9,483Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1319.1,1025q0,57.4-2.7,113.3h302.4a610.8,610.8,0,0,0,0-226.6H1316.4Q1319.1,967.5,1319.1,1025Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M730.9,1025q0-57.4,2.7-113.3H431.2a610.8,610.8,0,0,0,0,226.6H733.6Q730.9,1082.5,730.9,1025Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M806.1,1567c-31.9-95.9-54.5-212.1-66.1-338.7H455.7c3.8,10.8,7.9,21.4,12.4,32a606.3,606.3,0,0,0,321.6,321.6c8.3,3.5,16.7,6.8,25.1,9.9C811.9,1583.8,809,1575.5,806.1,1567Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1310,1228.3c-11.6,126.6-34.2,242.8-66.1,338.7-2.9,8.5-5.8,16.8-8.7,24.8,8.4-3.1,16.8-6.4,25.1-9.9a606.3,606.3,0,0,0,321.6-321.6c4.5-10.6,8.6-21.2,12.4-32Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1219.6,821.7q-4-41.1-9.6-80.9c-12.2-86.2-29.5-163.3-51.5-229.3-10.3-30.6-21.4-58.4-33.2-82.6a610.2,610.2,0,0,0-200.6,0c-11.8,24.2-22.9,52-33.2,82.6-22,66-39.3,143.1-51.5,229.3q-5.6,39.8-9.6,80.9Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M740,821.7c11.6-126.6,34.2-242.8,66.1-338.7,2.9-8.5,5.8-16.8,8.7-24.8-8.4,3.1-16.8,6.4-25.1,9.9A606.3,606.3,0,0,0,468.1,789.7c-4.5,10.6-8.6,21.2-12.4,32Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeGrid);
export default __webpack_public_path__ + "static/media/globe-grid.7973024e5763dfd636d63870e173dd85.svg";
export { ForwardRef as ReactComponent };